/**
 * Created by jerryhuali
 */
import CloudSealCard from './CloudSealCard.vue';

CloudSealCard.install = function (Vue, options) {
  if (options && options.lazy) {} else {
    Vue.component('CloudSealCard', CloudSealCard);
  }
};

export default CloudSealCard;